import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import Basket from '../../components/Basket/Basket'
import { ALLOWED_PAYMENTS, BASKET_TYPES } from '../../components/Basket/constants'
import { PAGE_NAME } from '../../components/OrderStepsHeader/constants'
import OrderStepsHeader from '../../components/OrderStepsHeader/OrderStepsHeader'
// import AddSnackCoupon from './components/AddSnackCoupon/AddSnackCoupon'
import { PATH_NAME } from '../../app/constants'
import HallMovie from '../Hall/components/HallMovie/HallMovie'
import { getCinemaSlug } from '../Hall/helpers'
import MovieRow from './components/MovieRow/MovieRow'

import hocYourOrder from './hocYourOrder'

import useSendBasketGtmInfo from 'services/gtm/useSendBasketGtmInfo'
import AddSnackCoupon from './components/AddSnackCoupon/AddSnackCoupon'
import './YourOrder.scss'

const YourOrder = ({
    isAuth,
    basketData,
    emptyBasket,
    basketLoading,
    setPayment,
    selectedPayment,
    eventid,
    cinemaid,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const referer = localStorage.getItem('referer')

    const site = getCinemaSlug(cinemaid)

    const onBuyHandler = () => {
        setPayment(ALLOWED_PAYMENTS.GOPAY)
        !isAuth ? dispatch(push(PATH_NAME.CONTACT_INFO)) : dispatch(push(PATH_NAME.ORDER_SUMMARY))
    }

    const onReserveHandler = () => {
        setPayment(ALLOWED_PAYMENTS.CASH)
        !isAuth ? dispatch(push(PATH_NAME.CONTACT_INFO)) : dispatch(push(PATH_NAME.ORDER_SUMMARY))
    }

    const vouchersInCard = basketData?.items_vouchers

    useSendBasketGtmInfo(basketData, site, 'begin_checkout')

    return (
        <Container fluid className={'your-order-page d-flex flex-column'}>
            <OrderStepsHeader
                isAuth={isAuth}
                eventid={eventid}
                emptyBasket={emptyBasket}
                active={PAGE_NAME.yourOrder}
                selectedPayment={selectedPayment}
                site={site}
                text={intl.formatMessage({ id: 'orderSteps.second' })}
                onClickBack={() => dispatch(push(`/?eventid=${eventid}&site=${site}&ref=${referer}`))}
            />

            <div className={'your-order-page--content d-flex flex-column mx-auto'}>
                {
                    /* JUST for SKELETON use*/ !basketData?.items_tickets?.length && basketLoading && (
                        <HallMovie loading={true} />
                    )
                }
                {basketData?.items_tickets?.map((item, indx) => (
                    <MovieRow
                        key={item?.event?.eventid}
                        firstMovie={indx === 0}
                        movie={item?.event}
                        page={PAGE_NAME.yourOrder}
                        tickets={item?.tickets}
                        loading={basketLoading}
                    />
                ))}
                <AddSnackCoupon vouchersInCard={vouchersInCard} ticketsLength={basketData?.items_tickets?.length} />
            </div>

            <Basket
                show={Boolean(basketData?.items_tickets?.length)}
                variant={BASKET_TYPES.PRICE}
                onReserve={onReserveHandler}
                onBuy={onBuyHandler}
                loading={basketLoading}
            />

            <img
                src={'images/cinestar/astronaut-thumbs-up.png'}
                alt={'astronaut-thumbs-up'}
                className={'astronaut-animate w-50 h-auto mx-auto'}
            />
        </Container>
    )
}

export default hocYourOrder(YourOrder)
